module.exports = __webpack_public_path__ + "static/Roboto-Black-3234b3e853eabe9fc936cd7a133055ad.ttf";